// src/api.js
import axios from 'axios';

const api = axios.create({
  // Use an empty baseURL so that requests are relative to the current origin
  baseURL: process.env.REACT_APP_BASE_URI || '',
});

// Automatically attach bearer token if present
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;